<!-- =========================================================================================
  File Name: TabContacts.vue
  Description: User Edit Contacts Tab content
========================================================================================== -->

<template>
  <div id="tab-contacts">
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2">

        <vs-input class="w-full mt-4" label="Адрес" v-model="partnerLocal.address" v-validate="'required'" name="address" data-vv-as="field" />
        <span class="text-danger text-sm"  v-show="errors.has('address')">{{ errors.first('address') }}</span>
        
        <vs-input class="w-full mt-4" label="Время работы" v-model="partnerLocal.worktime" v-validate="'required'" name="worktime" data-vv-as="field" />
        <span class="text-danger text-sm"  v-show="errors.has('worktime')">{{ errors.first('worktime') }}</span>

        <vs-input class="w-full mt-4" label="Телефон" v-model="partnerLocal.phone" v-validate="{regex: '^\\+?([0-9]+)$' }" name="phone" />
        <span class="text-danger text-sm"  v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
        
      </div>

      <div class="vx-col w-full md:w-1/2">

        <vs-input class="w-full mt-4" label="Web-сайт" v-model="partnerLocal.website" v-validate="'url:require_protocol'" name="website" data-vv-as="field" />
        <span class="text-danger text-sm"  v-show="errors.has('website')">{{ errors.first('website') }}</span>

        <vs-input class="w-full mt-4" label="E-mail" v-model="partnerLocal.email" v-validate="{regex: '^[a-zA-Z0-9.!#$%&\'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$' }" name="email" />
        <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>

      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" icon-pack="feather" icon="icon-chevron-left" :to="{ name: 'apps-partners-view', params:{ partnerId: $route.params.partnerId } }">Назад</vs-button>
          <vs-button class="ml-4 mt-2" icon-pack="feather" icon="icon-rotate-cw" type="border" color="warning" @click="reset_partner">Сброс</vs-button>
          <vs-button class="ml-4 mt-2" icon-pack="feather" icon="icon-save" color="success" @click="save_changes" :disabled="!validateForm">Сохранить</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      partnerLocal: Object.assign({}, this.$store.getters["partner/getPartner"]),
      partnerOriginal: Object.assign({}, this.$store.state.partner.partner),
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.partnerLocal.company && this.partnerLocal.phone
    }
  },
  methods: {
    save_changes() {
      if(!this.validateForm) return

      this.$store.dispatch("partner/updatePartner", this.partnerLocal)
      .then(() => {
        // this.$router.push({ name:'apps-partners-view', params: { partnerId: this.partnerLocal.partid } });
      })

    },
    reset_partner() {
      this.partnerLocal = Object.assign({}, this.partnerOriginal)
    },
  },
}
</script>
